import "../../App.css";
import "../admin/AdminChangePassword.css";
import { useState } from "react";
import toast from "react-hot-toast";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

export default function DoctorChangePassword() {
  const [oldpassword, setoldpassword] = useState("");
  const [newpassword, setnewpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const handleMouseDownPassword = (event) => event.preventDefault();

  return (
    <div className="container-fuild mx-2 mt-2">
      <div className="admin_change_passwords_main_diviison">
        <div className="admin_change_password_section">
          <FormControl sx={{ width: "100%" }} variant="outlined" className="mt-3">
            <InputLabel htmlFor="doctor-old-password">Old Password</InputLabel>
            <OutlinedInput
              id="doctor-old-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((show) => !show)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Old Password"
              value={oldpassword}
              onChange={(e) => setoldpassword(e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ width: "100%" }} variant="outlined" className="mt-3">
            <InputLabel htmlFor="doctor-new-password">New Password</InputLabel>
            <OutlinedInput
              id="doctor-new-password"
              type={showPassword2 ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword2((show) => !show)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="New Password"
              value={newpassword}
              onChange={(e) => setnewpassword(e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ width: "100%" }} variant="outlined" className="mt-3">
            <InputLabel htmlFor="doctor-confirm-password">Confirm Password</InputLabel>
            <OutlinedInput
              id="doctor-confirm-password"
              type={showPassword3 ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword3((show) => !show)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword3 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Confirm Password"
              value={confirmpassword}
              onChange={(e) => setconfirmpassword(e.target.value)}
            />
          </FormControl>

          <div className="admin_change_password_section_save_button_section mt-3">
            <button
              type="button"
              className="admin_change_password_section_save_button btn"
              onClick={() => {
                if (!oldpassword || !newpassword) {
                  toast.error("Please fill all fields");
                  return;
                }
                if (newpassword !== confirmpassword) {
                  toast.error("Password does not match");
                  return;
                }
                fetch(window.API_PREFIX + "admin/change_password", {
                  method: "POST",
                  headers: { "Content-type": "application/json" },
                  body: JSON.stringify({
                    Token: localStorage.getItem("DToken"),
                    Old_Password: oldpassword,
                    New_Password: newpassword,
                  }),
                })
                  .then((r) => r.json())
                  .then((data) => {
                    if (data?.status === "1") toast.success("Password successfully changed");
                    else toast.error(data?.message || "Change password failed");
                  })
                  .catch(() => toast.error("Change password failed"));
              }}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

